export default __webpack_public_path__ + "static/char-v-34-9df212dde9ea5dbf8775a73efc5d7ce9.webp";